import router from "@/router";
import axios from "axios";

export interface PostConfig {
  url: string;
  param?: any;
}
export function post(config: PostConfig): Promise<any> {
  return new Promise((resolve, reject) => {
    // 格式化参数
    const params = new URLSearchParams();
    if (config.param) {
      for (let key in config.param) {
        const value = config.param[key];
        if (isInclude(value, [null, undefined, 'null', 'undefined'])) {
          router.push({ path: '/400' });
          reject();
        }
        params.append(key, value);
      }
    }
    axios.post(config.url, params).then((res) => {
      let data: any = res.data;
      resolve(data);
    });
  });
}

/** 
 * value是否包含include中的值
 * @param value 
 * @param include 
 * @returns 返回布尔值
 */
export function isInclude(value: any, include: Array<any>): boolean {
  for (let i = 0; i < include.length; i++) {
    if (value === include[i]) {
      return true;
    }
  }
  return false;
}

/**
 * 延时操作
 * @param callback 延时方法
 * @param timeout 延时毫秒数
 */
export function delay(callback: any, timeout?: number) {
  let t = setTimeout(() => {
    if (t) clearTimeout(t);
    callback();
  }, timeout || 0);
}

/**
 * 获取数字区间的随机数
 * @param min 最小值
 * @param max 最大值
 */
export function randomNumber(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}